import { render, staticRenderFns } from "./navFootToo.vue?vue&type=template&id=6602d483&scoped=true&"
import script from "./navFootToo.vue?vue&type=script&lang=js&"
export * from "./navFootToo.vue?vue&type=script&lang=js&"
import style0 from "./navFootToo.vue?vue&type=style&index=0&id=6602d483&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6602d483",
  null
  
)

export default component.exports